import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-question-damage-image-parent',
    templateUrl: './question-damage-image-parent.component.html',
    styleUrls: ['./question-damage-image-parent.component.scss'],
    standalone: false
})
export class QuestionDamageImageParentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
